/**
 * Builds an ISO UTC instant for 19:00 on the picker's calendar day (browser local).
 * UK admins: matches club evening sessions without client timezone libraries.
 */
export function toScheduledAtIsoFromPickerDay(pickedDay: Date): string {
    const y = pickedDay.getFullYear();
    const m = pickedDay.getMonth();
    const d = pickedDay.getDate();
    return new Date(y, m, d, 19, 0, 0, 0).toISOString();
}
